export function isValidVerificationLink(link) {
  try {
    const decoded = decodeURIComponent(link);
    const url = new URL(decoded);

    const isHttps = url.protocol === "https:";
    const isAllowedHost = url.hostname === "us.onfido.app";
    const isAllowedPort = url.port === "" || url.port === "443";

    return isHttps && isAllowedHost && isAllowedPort;
  } catch (e) {
    return false;
  }
}
